import React, { useState, useEffect } from 'react';
import { getAuditLogs } from '../mocks/api';

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterCategory, setFilterCategory] = useState('all');

  useEffect(() => {
    (async () => {
      const data = await getAuditLogs();
      setLogs(data);
      setLoading(false);
    })();
  }, []);

  const filtered = filterCategory === 'all' ? logs : logs.filter(l => l.category === filterCategory);

  const categories = [...new Set(logs.map(l => l.category))];

  if (loading) return <div className="loading">Loading audit logs...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h2>Activity Logs</h2>
      </div>

      <div className="card">
        <div className="filter-bar">
          <div className="form-group">
            <label>Category</label>
            <select value={filterCategory} onChange={e => setFilterCategory(e.target.value)}>
              <option value="all">All Categories</option>
              {categories.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>

        <table className="table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>User</th>
              <th>Action</th>
              <th>Category</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(l => (
              <tr key={l.id}>
                <td className="timestamp-cell">{l.timestamp}</td>
                <td><strong>{l.userName}</strong></td>
                <td>{l.action}</td>
                <td><span className={`badge badge-cat-${l.category}`}>{l.category}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && <p className="empty-state">No logs found.</p>}
      </div>
    </div>
  );
}
